import React from 'react';

export default () => (
  <svg width="3" height="15" viewBox="-1 -1 5 17" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g fill="#000">
        <g>
          <path d="M2.75 3H0V0h3v3h-.25zm0 5.8H0v-3h3v3h-.25zm0 5.8H0v-3h3v3h-.25z" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/drag-handle.es6.js